import * as React from "react";
import {Datagrid, List, Pagination, TextField, TopToolbar} from 'react-admin';
import {Stack} from "@mui/material";

export const ParamsList = () => (
    <List title={'Rendszer paraméterek'}
          actions={
              <TopToolbar sx={{width: '100%', paddingTop: '20px'}}/>
          }
    >
        <Datagrid rowClick="edit" bulkActionButtons={false}>
            <TextField source="displayName" label={"Név"} sortable={false}/>
        </Datagrid>
    </List>
);
